import { useTranslation } from 'react-i18next';
import React from 'react';

import { Grid } from '@mui/material';
import { useGetMyTenantQuery } from '../../../api/tenant';
import { MongoDbDashboard } from '../../charts';
import {
  DashboardInfo,
  DashboardInfoHeader,
  DashboardLayout,
} from './dashboard.style';

function Analytics(): JSX.Element {
  const { t } = useTranslation();
  const welcomeMessage = t('dashboard.welcome.message');

  const { data } = useGetMyTenantQuery();

  const dashboarId = data?.getMyTenant?.dashboardId;

  return (
    <DashboardLayout>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DashboardInfo>
            {dashboarId ? (
              <div>
                <MongoDbDashboard dashboardId={dashboarId} />
              </div>
            ) : (
              <DashboardInfoHeader>
                {`${welcomeMessage} `}
                <span role="img" aria-label="confetti">
                  🎉
                </span>
              </DashboardInfoHeader>
            )}
          </DashboardInfo>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}

export { Analytics };
